













































import { defineComponent, ref } from '@nuxtjs/composition-api'
import IconFaSolidBars from '~icons/fa-solid/info-circle'

export default defineComponent({
  components: {
    IconFaSolidBars,
  },
  props: {
    specificitySensitivity: {
      type: String as () => string,
      default: undefined,
      required: false,
    },
    reacts: {
      type: String,
      default: undefined,
      required: false,
    },
    homologous: {
      type: String,
      default: undefined,
      required: false,
    },
  },
  setup() {
    const showpopup = ref(false)
    return {
      showpopup,
    }
  },
})
